/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Locations
 */
export interface Locations {
}

/**
 * Check if a given object implements the Locations interface.
 */
export function instanceOfLocations(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LocationsFromJSON(json: any): Locations {
    return LocationsFromJSONTyped(json, false);
}

export function LocationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Locations {
    return json;
}

export function LocationsToJSON(value?: Locations | null): any {
    return value;
}

